// The dispatch's lowercase convention, in one place.
//
// Everything innernet writes is lowercase (law_lowercase) except proper nouns,
// which the model is told to wrap in braces — {Vercel}, {OAuth}, {Supabase}. This
// strips the braces and lowercases everything else.
//
// It had been copy-pasted into three files (the reader, the email renderer and
// the dispatch skill's build script). Three copies of one rule is three chances
// for a surface to disagree about how the product sounds.

export function quiet(s = ''): string {
  return String(s).replace(/\{([^}]*)\}|([^{]+)/g, (_, keep, rest) =>
    keep !== undefined ? keep : String(rest).toLowerCase(),
  );
}
